import type {
  BackgroundColor,
  BorderColor,
  ColorGroup,
  TextColor,
} from '@lib/colors/colors'

export function getColorConfig(colorGroup: ColorGroup): {
  backgroundColor: BackgroundColor
  selectedBorderColor: BorderColor
  selectedTextColor: TextColor
  unselectedBorderColor: BorderColor
  unselectedTextColor: TextColor
} {
  switch (colorGroup) {
    case 'destructive':
      return {
        backgroundColor: 'bg-destructive50',
        selectedBorderColor: 'border-destructive500',
        selectedTextColor: 'text-destructive500',
        unselectedBorderColor: 'border-black',
        unselectedTextColor: 'text-black',
      }
    case 'success':
      return {
        backgroundColor: 'bg-success50',
        selectedBorderColor: 'border-success600',
        selectedTextColor: 'text-success600',
        unselectedBorderColor: 'border-black',
        unselectedTextColor: 'text-black',
      }
    case 'warning':
      return {
        backgroundColor: 'bg-warning50',
        selectedBorderColor: 'border-warning500',
        selectedTextColor: 'text-warning500',
        unselectedBorderColor: 'border-black',
        unselectedTextColor: 'text-black',
      }
    case 'darkGrey':
      return {
        backgroundColor: 'bg-neutral900',
        selectedBorderColor: 'border-success800',
        selectedTextColor: 'text-white',
        unselectedBorderColor: 'border-neutral700',
        unselectedTextColor: 'text-white',
      }
    case 'lightGrey':
      return {
        backgroundColor: 'bg-neutral50',
        selectedBorderColor: 'border-success400',
        selectedTextColor: 'text-success700',
        unselectedBorderColor: 'border-neutral200',
        unselectedTextColor: 'text-neutral900',
      }
    default:
      return {
        backgroundColor: 'bg-white',
        selectedBorderColor: 'border-black',
        selectedTextColor: 'text-black',
        unselectedBorderColor: 'border-black',
        unselectedTextColor: 'text-black',
      }
  }
}
